import documents, {initialState as documentsInitialState, State as DocumentsState} from 'ducks/Documents';
import fileUpload, {initialState as FileUploadInitState, State as FileUploadState} from 'ducks/FileUpload';
import messages, {initialState as messagesInitialState, State as MessagesState} from 'ducks/Messages';
import profile, {initialState as profileInitState, State as ProfileState} from 'ducks/Profile';
import selfService, {initialState as selfServiceInitState, State as SelfServiceState} from 'ducks/SelfService';
import sessionActivity, {
  initialState as sessionActivityInitState,
  State as SessionActivityState
} from 'ducks/SessionActivity';

export interface RootState {
  fileUpload: FileUploadState;
  profile: ProfileState;
  sessionActivity: SessionActivityState;
  selfService: SelfServiceState;
  documents: DocumentsState;
  messages: MessagesState;
}

export const initialRootState: RootState = {
  fileUpload: FileUploadInitState,
  profile: profileInitState,
  sessionActivity: sessionActivityInitState,
  selfService: selfServiceInitState,
  documents: documentsInitialState,
  messages: messagesInitialState
};

// Defer combining reducers to circumvent a circular dependancy issue
// between our duck files and `utils/api`
// The problem arises from a combination of defining action creators
// alongside the reducers and importing store into `utils/api`.

const reducers = {
  fileUpload,
  profile,
  sessionActivity,
  selfService,
  documents,
  messages
};

export default reducers;
